import { Link } from 'react-router-dom';
import logo from '../../assets/logo.jpg';

export default function Footer() {
  const handlePriceClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const priceSection = document.getElementById('price');
    if (priceSection) {
      priceSection.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/#price';
    }
  };

  const handleReserveClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open('https://example-reservation-system.com', '_blank');
  };

  return (
    <footer className="bg-black text-white mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-4"><img src={logo} alt='草加の美容室「9（ナイン)」' width="306px" height="345px" loading="eager" decoding="async" draggable="false" className="block h-16 md:h-16 w-auto" /></h3>
            <p className="text-gray-300 text-sm">
              カフェのような雰囲気の草加市の美容室9（ナイン）。落ち着いた雰囲気の中でリラックスしたひとときをお過ごしください。
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-gray-200">メニュー</h4>
            <div className="space-y-2">
              <button onClick={handlePriceClick} className="block text-gray-300 hover:text-white transition-colors text-left">
                Price
              </button>
              <Link to="/staff" className="block text-gray-300 hover:text-white transition-colors">
                Staff
              </Link>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-gray-200">インフォメーション</h4>
            <div className="space-y-2">
              <Link to="/news" className="block text-gray-300 hover:text-white transition-colors">
                News
              </Link>
              <button onClick={handleReserveClick} className="block text-gray-300 hover:text-white transition-colors text-left">
                Reserve
              </button>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4 text-gray-200">アクセス</h4>
            <div className="text-gray-300 space-y-1">
              <p>〒150-0001</p>
              <p>東京都渋谷区神宮前1-1-1</p>
              <p>TEL: 03-1234-5678</p>
              <p>営業時間: 10:00-20:00</p>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400">
            © 2025 nine. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
